import type { CheckoutState, GdprPlan } from './types';

const KEY = 'gdpr-checkout-state-v1';

export function readCheckout(): CheckoutState {
    if (typeof window === 'undefined') {
        return {};
    }

    try {
        const raw = window.sessionStorage.getItem(KEY);
        return raw ? (JSON.parse(raw) as CheckoutState) : {};
    } catch {
        return {};
    }
}

export function writeCheckout(patch: Partial<CheckoutState>): CheckoutState {
    const next = { ...readCheckout(), ...patch };
    window.sessionStorage.setItem(KEY, JSON.stringify(next));
    return next;
}

export function clearCheckout(): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.sessionStorage.removeItem(KEY);
}

export function currencySymbol(value: string): string {
    return value === 'EUR' ? '€' : value;
}

export function annualSavings(plan: GdprPlan): number {
    return plan.monthlyPrice * 12 - plan.annualPrice;
}
